(ns machtfit.stepchall.search
  (:require [clojure.string :as str]
            [machtfit.dashboard-widgets :as widgets]
            [machtfit.search :refer [search]]
            [machtfit.stepchall.icons :as icons]
            [machtfit.stepchall.pagination :as pagination]
            [machtfit.translation :refer [translate]]
            [re-frame.core :as rf]))

(defn init-db [fx]
  (assoc-in fx [:db :ui :stepchall :search] {}))

(rf/reg-event-fx ::changed
  (fn [_ [_ id query]]
    {:dispatch-debounce {:key :searchbar-change-request
                         :event [::debounced id query]
                         :delay 250}}))

(defn- update-query [db id query]
  (let [update-fn #(if (str/blank? query) nil 0)]
    (-> {:db db}
        (pagination/update-page :teams update-fn)
        (pagination/update-page :participants update-fn)
        (assoc-in [:db :ui :stepchall :search id :query] query))))

(rf/reg-event-fx ::delete-button-clicked
  (fn [{:keys [db]} [_ id]]
    (update-query db id "")))

(rf/reg-event-fx ::debounced
  (fn [{:keys [db]} [_ id query]]
    (update-query db id query)))

(rf/reg-sub ::query
  :<- [:get [:ui :stepchall :search]]

  (fn [search' [_ id]]
    (get-in search' [id :query])))

(rf/reg-sub ::matching-teams
  (fn [[_ id]]
    [(rf/subscribe [:get [:stepchall :teams]])
     (rf/subscribe [:get [:language]])
     (rf/subscribe [::query id])])

  (fn [[teams language query] _]
    (search {:items teams
             :query query
             :attribute-fn #(-> % :name (translate language))})))

(rf/reg-sub ::matching-participants
  (fn [[_ id]]
    [(rf/subscribe [:get [:stepchall :participants]])
     (rf/subscribe [::query id])])

  (fn [[participants query] _]
    (search {:items participants
             :query query
             :attribute-fn :nickname})))

(rf/reg-event-db ::focus
  (fn [db [_ id]]
    (assoc-in db [:ui :stepchall :search id :focused?] true)))

(rf/reg-event-db ::blur
  (fn [db [_ id]]
    (assoc-in db [:ui :stepchall :search id :focused?] false)))

(rf/reg-sub ::focused?
  (fn [_]
    [(rf/subscribe [:get [:ui :stepchall :search]])])

  (fn [[search'] [_ id]]
    (get-in search' [id :focused?])))

(def ^:private searchbar-style
  {:position "sticky"
   :top "3.5rem"
   :height 48
   :z-index 12
   :padding "0px 16px"})

(def ^:private input-style
  {:width "100%"
   :height 48
   :padding-top ".3em"
   :padding-left "2.625em"
   :border-width 1
   :border-style "solid"
   :border-color "#e7e8e8"
   :border-radius 24
   :outline 0
   :font-size ".875em"
   :box-shadow "0px 19px 48px 0px rgba(112, 144, 176, 0.2)"})

(def ^:private icon-style
  {:position "absolute"
   :top "1.6em"
   :left "1.875em"
   :transform "translateY(-50%)"})

(def ^:private delete-icon-style
  {:position "absolute" :top "1em" :right "1.875em"
   :cursor "pointer"})

(defn searchbar [{:keys [placeholder id]}]
  (let [query @(rf/subscribe [::query id])]
    [:div#sc_searchbar {:style searchbar-style}
     [widgets/input
      {:style (merge input-style
                     (when @(rf/subscribe [::focused? id]) {:border-color "#a0a6a6"}))
       :type "text"
       :placeholder (or placeholder {:de "Suchen…" :en "Search…"})
       :value query
       :on-change #(rf/dispatch [::changed id %])
       :on-focus #(rf/dispatch [::focus id])
       :on-blur #(rf/dispatch [::blur id])}]
     [:i {:style icon-style} [icons/search]]
     (when-not (str/blank? query)
       [:i {:style delete-icon-style
            :on-click #(rf/dispatch [::delete-button-clicked id])} [icons/close]])]))
